import * as framework from '../framework/export';
import * as common from './interceptor';

/**
 * 共通的な設定を行う
 * @param {ng.IModule} angularModule AngularJSのモジュール
 */
/* @ngInject */
export function config(
    $provide: ng.auto.IProvideService,
    $httpProvider: ng.IHttpProvider,
    $urlRouterProvider: ng.ui.IUrlRouterProvider,
    $stateProvider: ng.ui.IStateProvider,
    $translateProvider: ng.translate.ITranslateProvider
): void {
    // FWの共通設定を呼び出し
    framework.config($httpProvider);

    // $httpサービスに中断(インタセプター）処理を登録する。
    $httpProvider.interceptors.push(framework.interceptor);
    $httpProvider.interceptors.push(common.interceptor);

    // 多国語化の業務設定
    $translateProvider.fallbackLanguage(['ja', 'en', 'zh', 'id']);
    $translateProvider.useStaticFilesLoader(
        {
            prefix : '../assets/i18n/locale-',
            suffix : '.json'
        }
    );
    // 選択したロケール名をStorageLocalに格納する。
    $translateProvider.useLocalStorage();
    $translateProvider.useSanitizeValueStrategy('escapeParameters');
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/config.ts
 **/